import React, { useState, useEffect } from "react";
import Utils from "../utils/utils";
import { CiCalendarDate, CiShoppingTag, CiUser } from "react-icons/ci";
import { IoCloseSharp } from "react-icons/io5";
import { CiEdit, CiTrash } from "react-icons/ci";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { useToast } from "./ToastContext";
import { RxClock } from "react-icons/rx";

const AdminLectureCard = ({ props }) => {
  const {
    lecture,
    index,
    batchData,
    lectureFor,
    token,
    setLectures,
    handleLectureClick,
  } = props;

  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const showToast = useToast();

  const [editMode, setEditMode] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [anyOneCanSee, setAnyOneCanSee] = useState(
    lecture.anyone ? true : false
  );

  const [endDateTime, setEndDateTime] = useState({ date: "", time: "" });
  const [lectureData, setLectureData] = useState({
    title: lecture.title,
    remarks: lecture.remarks,
    lectureMode: lecture.lectureMode,
    instructorName: lecture.instructorName,
    category: lecture.category,
    batch: lecture.batch,
    videoLink: lecture.videoLink,
    joiningLink: lecture.joiningLink,
    date: lecture.date,
    lectureTime: lecture.lectureTime,
    endTime: endDateTime.time,
    endDate: endDateTime.date,
    lectureEndTime: lecture.lectureEndTime,
    time: lecture.time,
  });

  useEffect(() => {
    if (lecture?.lectureEndTime) {
      const { date, time } = Utils.getDateTimeUTCToLocal(
        lecture.lectureEndTime
      );
      setEndDateTime({ date, time });
      setLectureData((prev) => ({ ...prev, endTime: time, endDate: date }));
    }
  }, [lecture?.lectureEndTime]);

  const [batchList, setBatchList] = useState(() => {
    return batchData.filter((batch) => !lectureData.batch.includes(batch));
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLectureData((prev) => ({ ...prev, [name]: value }));
  };
  const handleEndDateTimeInput = (e) => {
    const { name, value } = e.target;
    setEndDateTime((prev) => ({ ...prev, [name]: value }));
  };

  const handleRemoveBatch = (batchName) => {
    setLectureData((prev) => ({
      ...prev,
      batch: prev.batch.includes(batchName)
        ? prev.batch.filter((batch) => batch !== batchName)
        : [...prev.batch, batchName],
    }));
    if (!batchList.includes(batchName)) {
      setBatchList((prev) => [...prev, batchName].sort());
    }
  };

  const handleBatchChange = (e) => {
    const { value } = e.target;
    setLectureData((prev) => ({ ...prev, batch: [...prev.batch, value] }));
    setSelectedBatch("");
    removeBatchInBatchList(value);
  };

  const removeBatchInBatchList = (batchName) => {
    setBatchList((prev) => prev.filter((batch) => batch !== batchName));
  };

  const handleCheckedAnyone = (e) => {
    const { checked } = e.target;
    setAnyOneCanSee(checked);
  };

  const HandleEditLectureSave = async () => {
    try {
      const lectureId = lecture._id;
      const formData = lectureData;
      formData["anyone"] = anyOneCanSee ? 1 : 0;
      formData["updatedAt"] = new Date(
        `${formData.date} ${formData.time}`
      ).toUTCString();

      // const lectureTime = new Date(`${formData.date} ${formData.time}`);
      // const lectureEndTime = new Date(
      //   `${endDateTime.date} ${endDateTime.time}`
      // );

      formData["lectureTime"] = Utils.getCreationTime(
        formData.date,
        formData.time
      );
      if (
        formData.endDate !== endDateTime.date ||
        formData.time !== endDateTime.time
      ) {
        formData["lectureEndTime"] = Utils.getCreationTime(
          endDateTime.date,
          endDateTime.time
        );
      }

      if (formData["lectureTime"] > formData["lectureEndTime"]) {
        showToast(
          "Lecture start time can't be more that the end time.",
          "warning",
          true,
          3000
        );
        return;
      }

      let response = await fetch(`${SERVER_URL}/lectures/${lectureId}`, {
        method: "PATCH",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
        body: JSON.stringify(lectureData),
      });

      if (response.ok) {
        response = await response.json();
        showToast(response.message, "success", true, 3000);

        const updatedLecture = response.lecture;
        setLectures((prev) =>
          prev.map((lecture) =>
            lecture._id === lectureId ? updatedLecture : lecture
          )
        );
      } else {
        response = await response.json();
        showToast(response.message, "info", true, 3000);
      }
    } catch (error) {
      alert("Something went wrong !");
    }
    setEditMode(false);
  };

  const handleCancelClick = () => {
    setEditMode(false);
  };

  const handleLectureDelete = async (lectureId) => {
    const confirm = window.confirm("Are you sure ?");
    if (!confirm) return;
    try {
      let response = await fetch(`${SERVER_URL}/lectures/${lectureId}`, {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
      });

      if (response.ok) {
        response = await response.json();
        showToast(response.message, "success", true, 3000);
        setLectures((prev) =>
          prev.filter((lecture) => lecture._id !== lectureId)
        );
      } else {
        response = await response.json();
        showToast(response.message, "info", true, 3000);
      }
    } catch (error) {
      // console.log("Error : ", error)
    }
  };

  return (
    <div className={`w-full`} key={`${lecture._id}-${index}`}>
      {editMode ? (
        <div
          bkl={"AdminLectureCardEdit" + lecture._id}
          key={"AdminLectureCardEdit" + lecture._id}
          className={`w-full relative bg-white  shadow-xl p-4 transition-all duration-2000 ease-in-out ${
            editMode ? "opacity-100 scale-100" : "opacity-0 scale-95"
          }`}
        >
          <div className="w-full flex gap-2 justify-between">
            <label className="form-control w-[50%]">
              <span className="label">Title</span>
              <input
                type="text"
                name="title"
                value={lectureData.title}
                required
                onChange={handleInputChange}
                className="input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-800 focus:bg-white focus:outline-none"
                placeholder="Lecture Title"
                title="Lecture Title"
              />
            </label>
            <label className="form-control w-[50%]">
              <span className="label">Remarks</span>
              <input
                type="text"
                name="remarks"
                value={lectureData.remarks}
                required
                onChange={handleInputChange}
                className="input-sm  px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                placeholder="Lecture Reamrks"
                title="Lecture Reamrks"
              />
            </label>
          </div>

          <div className="w-full flex gap-2 justify-between">
            <label className="form-control w-[25%]">
              <span className="label">Start Time</span>
              <input
                type="time"
                name="time"
                value={lectureData.time}
                onChange={handleInputChange}
                className="grow ml-2 input input-bordered input-sm focus:border-pink-500 focus:bg-white focus:outline-none"
                placeholder="Daisy"
              />
            </label>
            <label className="form-control w-[25%]">
              <span className="label">Start Date</span>
              <input
                type="date"
                name="date"
                value={lectureData.date}
                onChange={handleInputChange}
                className="grow input input-bordered input-sm focus:border-pink-500 focus:bg-white focus:outline-none"
                placeholder="Daisy"
              />
            </label>

            {lecture.lectureEndTime && (
              <>
                <label className="form-control w-[25%]">
                  <span className="label">End Time</span>
                  <input
                    type="time"
                    name="time"
                    value={endDateTime.time}
                    onChange={handleEndDateTimeInput}
                    className="grow ml-2 input input-bordered input-sm focus:border-pink-500 focus:bg-white focus:outline-none"
                  />
                </label>
                <label className="form-control w-[25%]">
                  <span className="label">End Date</span>
                  <input
                    type="date"
                    name="date"
                    value={endDateTime.date}
                    onChange={handleEndDateTimeInput}
                    className="grow input input-bordered input-sm focus:border-pink-500 focus:bg-white focus:outline-none"
                  />
                </label>
              </>
            )}

            <label className="form-control w-[25%]">
              <span className="label">Mode</span>
              <select
                name="lectureMode"
                value={lectureData.lectureMode}
                onChange={handleInputChange}
                className="select select-sm outline-gray-300 outline-1 focus:border-pink-500 outline focus:outline-none"
              >
                <optgroup label="Select Lecture Mode">
                  <option value="Live">Live</option>
                  <option value="Video">Video</option>
                  <option value="Reading">Reading</option>
                </optgroup>
              </select>
            </label>
            <label className="form-control w-[25%]">
              <span className="label">Category</span>
              <select
                name="category"
                value={lectureData.category}
                onChange={handleInputChange}
                className="select select-sm  outline-gray-300 outline-1 focus:border-pink-500 outline focus:outline-none"
              >
                <optgroup label="Select Category">
                  <option value="Coding">Coding</option>
                  <option value="DSA">DSA</option>
                  <option value="Assignment">Assignment</option>
                  <option value="Scrum">Scrum</option>
                  <option value="Other">Other</option>
                </optgroup>
              </select>
            </label>
          </div>

          <div className="flex items-center gap-2 w-full">
            <label className="form-control w-[50%] ">
              <span className="label">Joining Link </span>
              <input
                type="text"
                title="Joining Link"
                name="joiningLink"
                value={lectureData.joiningLink}
                onChange={handleInputChange}
                placeholder="Joining Link"
                className="input-sm   px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </label>

            <label className="form-control w-[50%]">
              <span className="label">Video Link </span>
              <input
                type="text"
                name="videoLink"
                value={lectureData.videoLink}
                onChange={handleInputChange}
                placeholder="Video URL"
                title="Video Link"
                className="input-sm px-4 py-3 rounded-lg bg-gray-50  border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </label>
          </div>

          <div className="flex items-center gap-2 w-full">
            <label className="form-control w-[50%]">
              <span className="label">Batches</span>
              <div className="flex flex-wrap gap-2">
                {lectureData.batch.map((batchName) => (
                  <button className="btn btn-xs" key={batchName}>
                    {batchName}{" "}
                    <IoCloseSharp
                      onClick={() => handleRemoveBatch(batchName)}
                    />
                  </button>
                ))}
              </div>
            </label>
            <div className="flex items-start gap-4 w-1/2">
              <label className="form-control w-1/2">
                <span className="label">Add Batch</span>
                <select
                  name="batch"
                  onChange={handleBatchChange}
                  className="select select-sm outline-gray-300 outline-1 focus:border-pink-500 outline focus:outline-none"
                  value={selectedBatch}
                >
                  <optgroup label="Select Batch">
                    <option value="" disabled>
                      Select Batch
                    </option>
                    {batchList.length &&
                      batchList.map((batch) => (
                        <option value={batch} key={batch}>
                          {batch}
                        </option>
                      ))}
                  </optgroup>
                </select>
              </label>

              <label className="form-control items-start">
                <span className="label">All</span>
                <input
                  type="checkbox"
                  name="anyone"
                  defaultChecked={anyOneCanSee}
                  onClick={handleCheckedAnyone}
                  className="checkbox  border-pink-800  [--chkbg:theme(colors.pink.800)] [--chkfg:white]"
                />
              </label>
            </div>
          </div>
          <div className="bg-white absolute right-[2%] bottom-[6%] flex gap-2">
            <button
              className="px-3 py-1 flex justify-center items-center gap-1 btn-xs  tracking-[.1em] uppercase border border-green-600 rounded-lg text-green-600 hover:text-green-800 hover:border-green-800 hover:shadow-lg  "
              onClick={HandleEditLectureSave}
            >
              Save
            </button>
            <button
              className="px-3 py-1 flex justify-center items-center gap-1 btn-xs  tracking-[.1em] uppercase border border-red-600 rounded-lg text-red-600 hover:text-red-800 hover:border-red-800 hover:shadow-lg  "
              onClick={handleCancelClick}
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <div
          bkl="AdminLectureCard"
          key={`AdminLectureCard-${lecture._id}-${index * index}`}
          className={`p-4 group relative cursor-pointer bg-white shadow-md  hover:shadow-lg w-full hover:bg-gray-50 rounded-xl ${
            lectureFor === "all" && "-mr-2"
          }`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleLectureClick(lecture);
          }}
        >
          <div className="flex  flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
            <div className="order-2 flex-1 space-y-4 sm:order-1  ">
              <div className="flex flex-row gap-3 items-center">
                <p className="font-semibold text-lg">{lecture.title}</p>
                <span
                  className={`text-xs uppercase px-2 py-1 font-medium rounded-lg ${
                    lecture.lectureMode === "Live"
                      ? "bg-[#eefcff] text-[#049402]"
                      : "bg-[#FAF5FF] text-[#97266D]"
                  }`}
                >
                  {lecture.lectureMode}
                </span>
              </div>
            </div>

            <div className="order-1 flex flex-row gap-3 sm:order-2 ">
              <button
                className="px-2 py-1 flex justify-center items-center gap-1 btn-xs  tracking-[.1em] uppercase border border-blue-600 rounded-lg text-blue-600 hover:text-blue-800 hover:border-blue-800 hover:shadow-lg  "
                onClick={(e) => {
                  e.stopPropagation();
                  setEditMode(true);
                }}
              >
                Edit <CiEdit />
              </button>
              <button
                className="flex items-center gap-1 px-2  tracking-[.1em] btn-xs  uppercase border border-red-600 rounded-lg text-red-600 hover:text-red-800 hover:border-red-800 hover:shadow-lg  "
                onClick={(e) => {
                  e.stopPropagation();
                  handleLectureDelete(lecture._id);
                }}
              >
                Delete <CiTrash />{" "}
              </button>
            </div>
          </div>

          {lecture.remarks && (
            <div className="italic mt-2">
              <p className="">{lecture.remarks}</p>
            </div>
          )}

          <div className="mt-2 flex flex-wrap gap-4 overflow-hidden text-[#544D4F] w-3/4">
            <div className="flex items-center">
              <CiUser className="w-5 mr-2" />
              <span>{lecture.instructorName}</span>
            </div>

            <div className="flex items-center">
              <CiCalendarDate className="w-6 mr-2" />
              <span className="text-[#544D4F]">
                {Utils.formatDateTime(lecture.lectureTime)}
              </span>
            </div>

            <div className="flex items-center">
              <CiShoppingTag className="w-6 mr-2 transform scale-x-[-1]" />
              <span className="text-[#544D4F]">{lecture.category}</span>
            </div>

            {lecture.lectureEndTime && (
              <div className="flex items-center">
                <RxClock className="w-6 mr-2 transform scale-x-[-1]" />
                <span className="text-[#544D4F]">
                  {(() => {
                    const { hours, minutes } = Utils.getLectureDuration(
                      lecture.lectureTime,
                      lecture.lectureEndTime
                    );
                    return `${hours} hrs ${minutes} minutes`;
                  })()}
                </span>
              </div>
            )}
          </div>

          <div className="mt-2">
            {lecture.anyone ? (
              <span className="inline-flex items-center gap-1 rounded-full bg-pink-100 px-3 py-1 text-xs font-medium text-pink-700">
                All Batches
                <IoIosCheckmarkCircleOutline className="w-5 h-5 font-extrabold" />
              </span>
            ) : (
              <div className="flex flex-wrap gap-2">
                {lecture.batch.map((batch) => (
                  <span
                    key={batch}
                    className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600"
                  >
                    {batch}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminLectureCard;
